// src/app/admindashobard/components/AdminLayout.jsx

import * as React from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Colors } from "../../utils/Colors";
import AdminSidebar, { drawerWidth } from "./AdminSidebar";
import AdminTopbar from "./AdminTopHeader";

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: Colors.bg.app }}>
      <AdminTopbar onMenuClick={handleDrawerToggle} />
      <AdminSidebar open={mobileOpen} onClose={handleDrawerToggle} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          bgcolor: Colors.bg.app,
        }}
      >
        <Toolbar sx={{ minHeight: "84px !important" }} />
        <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}